import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

@Injectable()
export class GenericIntegrationService {

  path = '/generic-integration';

  constructor(private baseService: BaseService) { }

  getPaginated(init: number, end: number) {
    return this.baseService.get(this.path, '', { init, end });
  }

  findByPk(id: number) {
    return this.baseService.get(this.path, '/' + id);
  }

  post(list: any) {
    return this.baseService.post(this.path, '/', list);
  }

  put(list: any) {
    return this.baseService.put(this.path, '/', list);
  }

  delete(id: number) {
    return this.baseService.delete(this.path, '/' + id);
  }

  save(list: any) {
    if (list.id) { return this.put(list); } else { return this.post(list); }
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/generic-integration.service.ts